import { render, staticRenderFns } from "./CreateDigiBoards.vue?vue&type=template&id=401ea689&scoped=true"
import script from "./CreateDigiBoards.vue?vue&type=script&lang=js"
export * from "./CreateDigiBoards.vue?vue&type=script&lang=js"
import style0 from "./CreateDigiBoards.vue?vue&type=style&index=0&id=401ea689&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401ea689",
  null
  
)

export default component.exports